<template>
   <a :title="`${data.name}`" style="display:inline; font-weight:100; text-decoration: underline; 
   		color:#dddddd; cursor: pointer;">{{data.name}}</a>
</template>
 
<script>
export default {
  data () {
    return {
        data: {}
    }
  }
}
</script>